export default __webpack_public_path__ + "static/media/fb.0b728ab3.svg";